import React from "react";
import "./styles/Card.css";
import CountdownTimer from "./CountdownTimer.js";

const CardQVEMA = ({ title, description, imageUrl }) => {
  return (
    <div className="card" style={{backgroundColor: '#333'}}>
      {imageUrl && <a href='https://www.m6.fr/qui-veut-etre-mon-associe-la-suite-p_21204' target='_blank'><img src={imageUrl} alt={title} className="card-image" /></a>}
    </div>
  );
};

export default CardQVEMA;
